import { createSelector } from 'reselect'

export const campaignTagsSelector = (state) => state.campaigns.tags
export const campaignsSelector = (state) => state.campaigns.campaigns
export const campaignsByIdSelector = (state) =>
  (state.campaigns.campaigns || {}).byCampaignId || {}

export const selectCampaignTags = createSelector(
  [campaignTagsSelector],
  (tags) => {
    return {
      tags,
    }
  },
)

export const selectCampaigns = createSelector(
  [campaignsSelector],
  (campaigns) => {
    return {
      campaigns,
    }
  },
)

export const selectCampaignsById = createSelector(
  [campaignsByIdSelector],
  (campaignsById) => {
    return {
      byCampaignId: campaignsById,
    }
  },
)
